import type { ReactNode } from 'react';
import type { Country } from 'react-phone-number-input';

import { PhoneInputLoadable } from '#/components/PhoneInput/PhoneInputLoadable';

import { Field } from './Field/Field';

type Props = {
  description?: string | ReactNode;
  disabled?: boolean;
  initialValueFormat?: 'national' | undefined;
  defaultCountry?: Country;
  label?: string;
  name: string;
  placeholder?: string;
  value?: string;
};

export function PhoneField({
  description,
  disabled,
  initialValueFormat,
  defaultCountry,
  label,
  name,
  placeholder,
  ...props
}: Props) {
  return (
    <Field
      inputProps={props}
      description={description}
      name={name}
      label={label}
      renderInput={({
        qaId,
        updateValue,
        value,
      }: {
        qaId: string;
        updateValue: (v?: string) => void;
        value: string | undefined;
      }) => (
        <PhoneInputLoadable
          className="phone-input"
          disabled={disabled}
          qaId={qaId}
          name={name}
          placeholder={placeholder}
          initialValueFormat={initialValueFormat}
          onChange={(v?: string) => {
            updateValue(v);
          }}
          value={value ?? ''}
          defaultCountry={defaultCountry}
        />
      )}
    />
  );
}

// || getUserTimezone()
